import script from "./mobileAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileAbout.vue?vue&type=script&setup=true&lang=js"

import "./mobileAbout.css?vue&type=style&index=0&id=2312eb10&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2312eb10"]])

export default __exports__